import { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { ListCell } from '@src/components/table-list/cells'
import { Subtitle1, Subtitle2 } from '@src/elements/typography/typography'
import Member from '@src/data/member'
import { Icon } from '@src/elements/icon/icon'

@Component
export class NameCell extends ListCell {
  item: Member

  @Prop({ required: false })
  click: () => void

  @Prop({ required: false, default: false })
  showAlert: boolean

  onClick () {
    this.click()
  }

  render (h: CreateElement) {
    return <div onClick={this.onClick} class='cell name-cell '>
      <Subtitle1>{this.showAlert && <Icon class='alert-icon' name='util/alert' />} <span>{this.item.fullName} </span></Subtitle1>
      <Subtitle2>
        {this.item.username}
      </Subtitle2>
    </div>
  }
}
